<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{ $t('keywords.register') }}</v-toolbar-title>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.serverName)"
                  name="serverName"
                  :label="$t('keywords.id')"
                  v-model="objEditar.serverName"
                />
              </v-col>

              <v-col cols="12" md="5">
                <v-text-field
                  :rules="requiredRules(objEditar.serverHost)"
                  name="serverHost"
                  :label="$t('emailserver.host_name')"
                  v-model="objEditar.serverHost"
                />
              </v-col>
              <v-col cols="12" md="1" sm="2">
                <v-text-field :label="this.$t('emailserver.port')" name="serverPort" v-model="objEditar.serverPort"/>
              </v-col>
              <v-col cols="12" md="1" sm="2">
                <v-switch :label="$t('emailserver.required')" v-model="objEditar.secureRequired" />
              </v-col>
              <v-col v-if="useCredential" cols="12" md="4">
                <CredentialSelect
                  name="credentialName"
                  :label="$t('emailserver.email_credential')"
                  v-model="objEditar.credentialName"
                  :required="useCredential"
                  type="EMAIL"
                />
              </v-col>

              <v-col cols="12" :md="useCredential ? 6 : 10">
                <v-text-field
                  name="sourceEmail"
                  :label="$t('emailserver.origem')"
                  v-model="objEditar.from"
                  :rules="emailRules(objEditar.from)"
                  prepend-icon="mdi-at"
                />
              </v-col>

              <v-col cols="12" md="1" sm="2">
                <v-switch
                  v-if=" $versionable.versions.emailServer > '1.0.0' "
                  :label="$t('emailserver.notification_server')"
                  v-model="objEditar.notificationServer"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6">
                <List
                  v-if=" $versionable.versions.emailServer > '1.0.0' "
                  v-show="objEditar.notificationServer"
                  v-model="objEditar.notificationList"
                  :required="!!objEditar.notificationServer && $versionable.versions.emailServer > '1.0.0' "
                  :label="$t('emailserver.notification_list')"
                  :inputLabel="$t('emailserver.add_email')"
                />
              </v-col>
                <v-col cols="6" class="text-right" style="position:relative;left:0">
                <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
                <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/EmailServerService'
import CredentialSelect from '../core/CredentialSelect'
import LocalStorageService from '../../services/LocalStorageService'
import { alphaNumericRules, requiredRules, emailRules } from '../../utils/rules'
import List from '../core/List.vue'

export default {
  name: 'credentialForm',

  components: {
    CredentialSelect,
    List
  },

  props: {
    identifier: String
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    emailRules,
    objEditar: {
      serverName: '',
      serverHost: '',
      credentialName: '',
      secureRequired: true,
      clientPrefix: '',
      serverPort: '',
      notificationServer: 0,
      notificationList: []
    },
    isUpdating: false
  }),

  mounted () {
    this.loadDB()
  },

  computed: {
    useCredential () {
      return this.$versionable.versions.emailServer < '1.5.4' ? true : this.objEditar.secureRequired
    }
  },

  methods: {
    loadDB () {
      if (this.identifier) {
        Servico.findById(this.identifier)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()

      if (this.$refs.form.validate()) {
        if (this.isUpdating) {
          this.updateItem()
        } else {
          this.createItem()
        }
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }

  }
}
</script>
